module.exports = __webpack_public_path__ + "static/vmware_6.be72c744.jpg";